import api, { handleApiError } from './api';
import type { Contract } from '@/types';

//TODO: Handle insertID
//TODO: Handle search
// Description: Create a new contract
// Endpoint: POST /api/clc/contracts
// Request: { contract: Contract }
// Response: { success: boolean, contract: Contract, message: string }
export const createContract = async (contractData: Omit<Contract, '_id'>) => {
    try {
        
        console.log('Creating Contracts, ',JSON.stringify(contractData, null, 2));

        // Make the actual API call instead of mocking
        const response = await api.post('/api/clc/contracts', { contract: contractData });
        return response.data;
    } catch (error: any) {
        if (error.response) {
            console.error('Server responded with an error:', error.response.data);
            return error.response.data; // Return the error response for better error handling
        } else {
            console.error('Error creating contract:', error.message);
            throw error;
        }
    }
};

// Description: Update an existing contract
// Endpoint: PUT /clc/contracts/{contractId}
// Request: { contract: Partial<Contract> }
// Response: { success: boolean, contract: Contract, message: string }
export const updateContract = async (contractId: number, contractData: Contract) => {
    try {
      // Ensure the full contract object is sent to the API
    //   const dataToSend = {
    //     ...contractData,
    //     isNoBookingRequired: contractData.isNoBookingRequired !== undefined
    //       ? contractData.isNoBookingRequired
    //       : false,
    //     archiveStatus: contractData.archiveStatus || 'pending', // Default to 'pending' if not defined
    //   };
  
    //   console.log(`Updating contract ${contractId} with data:`, contractData);
    //   console.log('Udpdating Contracts, ',JSON.stringify(contractData, null, 2));

      // Make the actual API call
      const response = await api.put(`/api/clc/contracts/${contractId}`, { contract: contractData });
  
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Server responded with an error:', error.response.data);
        return error.response.data; // Return the error response for better error handling
      } else {
        console.error('Error updating contract:', error.message);
        throw error;
      }
    }
  };

// Description: Delete an existing contract
// Endpoint: DELETE /clc/contracts/{contractId}
// Response: { success: boolean, message: string }
export const deleteContract = async (contractId: number) => {
    try {
        // Convert contractId to string just in case it's a number
        const id = contractId;

        // Make the actual API call instead of mocking
        const response = await api.delete(`/api/clc/contracts/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            console.error('Server responded with an error:', error.response.data);

            // If 404 error, it might be that the contract was already deleted
            if (error.response.status === 404) {
                return { success: true, message: "Contract was already deleted or does not exist" };
            }

            return error.response.data; // Return the error response for better error handling
        } else {
            console.error('Error deleting contract:', error.message);
            throw error;
        }
    }
};

// Description: Get all contracts
// Endpoint: GET /api/clc/contracts
// Response: { success: boolean, contracts: Contract[], message: string }
export const getContracts = async (params?: { size?: number; page?: number; search?: string }) => {
    try {
        // Build query string if params are provided
        const queryParams = new URLSearchParams();
        if (params?.size) {
            queryParams.append('size', params.size.toString());
        }
        if (params?.page) {
            queryParams.append('page', params.page.toString());
        }
        if (params?.search) {
            queryParams.append('search', params.search);
        }

        const queryString = queryParams.toString();
        const url = queryString ? `/api/clc/contracts?${queryString}` : '/api/clc/contracts';

        // Make the actual API call instead of mocking
        const response = await api.get(url);

        // console.log('Get Contracts, ',JSON.stringify(response.data, null, 2));

 
        return response.data;
    } catch (error: any) {
        console.error('Error fetching contracts:', error);
        if (error.response) {
            return error.response.data; // Return the error response for better error handling
        }
        // Return empty array on error to prevent app from crashing
        return {
            success: false,
            contracts: [],
            message: "Failed to fetch contracts"
        };
    }
};

// Description: Get all pending contracts
// Endpoint: GET /api/contracts/pending
// Request: {}
// Response: { contracts: PendingContract[] }
export const getPendingContracts = (contracts: Contract[]) => {
    // Convert pending contracts to pending contracts
    const pendingContracts = contracts
        .filter(contract => contract.status === 'pending')
        .map(contract => ({
            _id: contract._id,
            contractId: contract._id,
            contractDate: new Date().toISOString().split('T')[0],
            status: 'pending',
        }));

    return Promise.resolve(pendingContracts);
};

// Description: Get contract summary
// Response: Contract object
export const getContractSummary = async (contracts: Contract[], contractId: number) => {
    // Find contract in the provided contracts array
    const contract = contracts.find(c => c._id === parseInt(contractId as unknown as string));

    if (!contract) {
        throw new Error('Contract not found');
    }

    return contract;
};

// Description: Get a single contract by ID
// Endpoint: GET /clc/contracts/{_id}
// Response: { success: boolean, contract: Contract, message: string }
export const getContract = async (contractId: number) => {
    try {
        // Make the actual API call instead of mocking
        const response = await api.get(`/api/clc/contracts/${contractId}`);
        console.log('Contract fetched successfully:', response.data.contract);

        return response.data;
    } catch (error: any) {
        console.error(`Error fetching contract with ID ${contractId}:`, error);
        if (error.response) {
            return error.response.data; // Return the error response for better error handling
        }
        throw new Error(`Failed to fetch contract with ID ${contractId}`);
    }
};